/**
 *
 * @param { String } FILE_URL Url of script to load
 * @param { Boolean } async If true, the script is loaded asynchronously
 * @param { String } type Type of the script tag
 * @returns Promise
 */
export const loadScript = (
  FILE_URL,
  async = true,
  type = "text/javascript"
) => {
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement("script");

    scriptElement.type = type;
    scriptElement.async = async;
    scriptElement.src = FILE_URL;

    scriptElement.onload = resolve;
    scriptElement.onerror = reject;
    document.head.appendChild(scriptElement);
  });
};

/**
 * Sustituya a loadScriptAsync o loadScript
 * @param {String} url La url de la librería a cargar
 * @returns Una promesa de cada carga de la librería
 */
export function loadLib(url, idTag) {
  return new Promise((resolve, reject) => {
    globalThis.idTagDelio = idTag
    const script = globalThis.document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => {
      resolve(); // Carga
    };
    script.onerror = reject; // No carga
    document.head.appendChild(script);
  });
}

/**
 * 
 * @param {Array} libs Array de objetos con las librerías a cargar
 */
export async function loadAllLibs(libs) {


  try {
    console.log('entro aqui por')
    const promises = libs.map(lib => loadLib(lib.url))
    await Promise.all(promises)
  } catch (error) {
    console.error(errorWalmeric)
  }

}


/**
 *
 * @param { Array } arrayPromises Array of Promises to resolve
 * @returns response
 */

export const loadMultiScript = async (arrayPromises) => {
  try {
    const promises = await Promise.all(arrayPromises);
    return promises;
  } catch (error) {
    console.log(error);
  }
};

/***
 * Funcion que dado un parametro de busqueda , busca en la url y devuelve el valor de dicho parametro si lo encuentra
 * @param {String} paramSearch parametro de busqueda
 * @return {String} valor params
 * 
*/

export function getSearchParamValueUrl(paramSearch) {
  return new Promise((resolve, reject) => {
    try {
      // Verificar si el parámetro 'paramSearch' fue pasado
      if (!paramSearch) {
        resolve(`Falta el parámetro de búsqueda ${paramSearch}`);
        return;
      }

      // Obtener la cadena de consulta de la URL
      const searchParams = new URLSearchParams(window.location.search);

      // Revisar si el parámetro existe
      if (!searchParams.has(paramSearch)) {
        resolve(null);
        return;
      }

      // Obtener el valor del parámetro
      const value = searchParams.get(paramSearch);

      // Si el valor está vacío, resolver con null
      if (value === '') {
        resolve("error valor vacio");
        return;
      }

      // Resolver la promesa con el valor del parámetro
      resolve(value);
    } catch (error) {
      // En caso de cualquier error, rechazar la promesa con el error
      reject(`Error al buscar el parámetro "${paramSearch}": ${error.message}`);
    }
  });
}

// Ejemplo de uso
getSearchParamValueUrl('miParametro')
  .then(valor => {
    console.log(`El valor del parámetro es: ${valor}`);
  })
  .catch(error => {
    console.error(error);
  });





